import { Box } from "@mui/material";
import React from "react";
import UserWithdrawsConnections from "./UserWithdrawsConnections.component";


const UserWithdraws=({ userId }) => {
    return (
        <Box>
            <UserWithdrawsConnections userId={userId} />
        </Box>
    );
}

export default UserWithdraws;